export const workshops = [
  {
    title: "Kargil Victory Celebration",
    description:
      "A patriotic event held to honor the brave soldiers of the Indian Armed Forces. Students participated in flag hoisting, patriotic song performances, and inspirational speeches.",
    images: [
      "/images/events/kargil/1.jpg",
      "/images/events/kargil/2.jpg",
      "/images/events/kargil/3.jpg",
      "/images/events/kargil/4.jpg",
      "/images/events/kargil/5.jpg",
      "/images/events/kargil/6.jpg",
    ],
  },
  {
    title: "Temple Place Cleaning",
    description:
      "Volunteers engaged in seva by cleaning temple surroundings, promoting hygiene, environmental consciousness, and the spirit of selfless service in community spaces.",
    images: [
      "/images/events/templecleaning/1.jpg",
      "/images/events/templecleaning/2.jpg",
      "/images/events/templecleaning/3.jpg",
      "/images/events/templecleaning/4.jpg",
      "/images/events/templecleaning/5.jpg",
      "/images/events/templecleaning/6.jpg",
    ],
  },
  {
    title: "Children Residential Workshop",
    description:
      "A 3-day immersive workshop where children experienced character-building activities, yoga, stories from Indian epics, bhajans, games, and value education in a joyful residential setting.",
    images: [
      "/images/events/public/21.jpg",
      "/images/events/public/22.jpg",
      "/images/events/vanavasiseva/1.jpg",
      "/images/events/4.jpg",
      "/images/events/sharadapooja/7.jpg",
    ],
  },
  {
    title: "Guru Poornima Celebration",
    description:
      "A reverent occasion where students honored teachers and mentors through devotional events.",
    images: [
      "/images/events/gurupoornima/1.jpg",
      "/images/events/gurupoornima/2.jpg",
      "/images/events/gurupoornima/3.jpg",
      "/images/events/gurupoornima/4.jpg",
    ],
  },
  {
    title: "Sister Niveditha Jayanti",
    description:
      "An observance of Sister Niveditha’s life, focusing on her service in education and women empowerment.",
    images: [
      "/images/events/niveditha/1.jpg",
      "/images/events/niveditha/2.jpg",
      "/images/events/niveditha/3.jpg",
      "/images/events/niveditha/4.jpg",
      "/images/events/niveditha/5.jpg",
    ],
  },
  {
    title: "Vanavasi Seva",
    description:
      "An outreach initiative to serve tribal communities with health checkups, education kits, and support.",
    images: [
      "/images/events/vanavasiseva/1.jpg",
      "/images/events/vanavasiseva/2.jpg",
      "/images/events/vanavasiseva/3.jpg",
      "/images/events/vanavasiseva/4.jpg",
      "/images/events/vanavasiseva/5.jpg",
    ],
  },
  {
    title: "Books Distribution",
    description:
      "Educational books were distributed to students to promote reading habits and support academic growth.",
    images: [
      "/images/events/booksdistribution/1.jpg",
      "/images/events/booksdistribution/2.jpg",
      "/images/events/booksdistribution/3.jpg",
      "/images/events/booksdistribution/4.jpg",
      "/images/events/booksdistribution/5.jpg",
    ],
  },
  {
    title: "Clothes Distribution",
    description:
      "Essential clothing items were distributed to the needy, aiming to provide dignity and comfort.",
    images: [
      "/images/events/clothesdistribution/1.jpg",
      "/images/events/clothesdistribution/2.jpg",
      "/images/events/clothesdistribution/3.jpg",
      "/images/events/clothesdistribution/4.jpg",
      "/images/events/clothesdistribution/5.jpg",
    ],
  },
  {
    title: "Freedom Fighters Books Distribution",
    description:
      "Books highlighting the contributions of freedom fighters were distributed to inspire young minds.",
    images: [
      "/images/events/freedomfighterbooks/1.jpg",
      "/images/events/freedomfighterbooks/2.jpg",
      "/images/events/freedomfighterbooks/3.jpg",
    ],
  },
];
